import React from "react";
import { PlacesType, Tooltip } from "react-tooltip";
import { BrandContext } from "../../contexts/BrandContext";

interface TooltipProps {
  id: string;
  tooltipClassnames?: string;
  place?: PlacesType;
  isOpen: boolean;
  children?: React.ReactNode;
}

const CustomTooltip: React.FC<TooltipProps> = (props) => {
  const { place, id, isOpen, children } = props;
  const brandValue = React.useContext(BrandContext);

  return (
    <Tooltip
      id={id}
      isOpen={isOpen}
      place={place ?? "right"}
      style={{
        backgroundColor: brandValue.primary_color,
        color: brandValue.button_font_color,
      }}
    >
      {children}
    </Tooltip>
  );
};

export default React.memo(CustomTooltip);
